import { Link } from 'react-router-dom'
import type React from "react"
import "./portfolioItem.scss"

interface PortfolioItemProps {
  id?: string
  projectName: string
  projectDescription: string
  screenshotUrl: string
  logoUrl?: string
}

const PortfolioItem: React.FC<PortfolioItemProps> = ({
  id,
  projectName,
  projectDescription,
  screenshotUrl,
  logoUrl,
}) => {
  const projectPath = id
    ? `/portfolio/${id}`
    : `/portfolio/${projectName.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <div className="portfolioItem">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="projectInfo p-4">
              {logoUrl && (
                <Link to={projectPath}>
                  <div className="logoContainer mb-4">
                    <img src={logoUrl || "/placeholder.svg"} alt={`${projectName} logo`} className="projectLogo" />
                  </div>
                </Link>
              )}
              <Link to={projectPath} className="projectNameLink">
                <h2 className="projectName">{projectName}</h2>
              </Link>
              <p className="projectDescription">{projectDescription}</p>
            </div>
          </div>
          <div className="col-md-8">
            <Link to={projectPath}>
              <div className="screenshotContainer">
                <img
                  src={screenshotUrl || "/placeholder.svg"}
                  alt={`${projectName} screenshot`}
                  className="projectScreenshot img-fluid"
                />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PortfolioItem
